export default __webpack_public_path__ + "static/media/Silver-Bangles-&-Kada.36eb8dfd.jpg";